<template>
  <v-dialog
    :value="dialog"
    persistent
    max-width="560"
    @input="$emit('update:dialog', $event)"
  >
    <v-card class="parchment-bulk-delete-dialog">
      <v-toolbar class="parchment-bulk-delete-dialog__toolbar" flat dark>
        <v-toolbar-title class="white--text font-weight-bold">
          {{ $t("memberDataSection.parchmentDelivery.bulkImport.deleteDataTitle") }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="onCancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="parchment-bulk-delete-dialog__body pt-5 pb-2 black--text">
        <p class="parchment-bulk-delete-dialog__question mb-0">
          {{ confirmMessage }}
        </p>
      </v-card-text>

      <v-card-actions class="parchment-bulk-delete-dialog__actions px-6 pb-5 pt-4">
        <v-spacer></v-spacer>
        <v-btn
          outlined
          height="40"
          min-width="120"
          class="text-uppercase font-weight-bold mr-3 parchment-bulk-delete-dialog__cancel-btn"
          :class="{ 'parchment-bulk-delete-dialog__cancel-btn--kenya': isKenyaClient }"
          @click="onCancel"
        >
          {{ $t("cancel") }}
        </v-btn>
        <v-btn
          depressed
          height="40"
          min-width="120"
          class="text-uppercase font-weight-bold white--text parchment-bulk-delete-dialog__delete-btn"
          :class="{ 'parchment-bulk-delete-dialog__delete-btn--kenya': isKenyaClient }"
          :color="isKenyaClient ? undefined : 'primary'"
          @click="onConfirm"
        >
          {{ $t("delete") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { isKenyaClient } from "@/utils";

export default {
  name: "ParchmentDeliveryBulkDeleteConfirmDialog",
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    recordCount: {
      type: Number,
      default: 0,
    },
    issueTypeLabel: {
      type: String,
      default: "",
    },
    singleRecord: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isKenyaClient() {
      return isKenyaClient();
    },
    confirmMessage() {
      const base = "memberDataSection.parchmentDelivery.bulkImport";
      if (this.singleRecord) {
        return this.$t(`${base}.deleteDataConfirmQuestionSingle`);
      }
      if (this.issueTypeLabel) {
        return this.$t(`${base}.deleteDataConfirmQuestionIssueType`, {
          count: this.recordCount,
          issueType: this.issueTypeLabel,
        });
      }
      return this.$t(`${base}.deleteDataConfirmQuestion`, {
        count: this.recordCount,
      });
    },
  },
  methods: {
    onCancel() {
      this.$emit("cancel:action");
    },
    onConfirm() {
      this.$emit("continue:action");
    },
  },
};
</script>

<style scoped lang="scss">
.parchment-bulk-delete-dialog__toolbar {
  background-color: #1b5e20 !important;
}

.parchment-bulk-delete-dialog__body {
  text-align: left;
  font-size: 14px;
  line-height: 1.5;
}

.parchment-bulk-delete-dialog__question {
  font-size: 14px;
  color: #212121;
}

.parchment-bulk-delete-dialog__cancel-btn--kenya {
  border-color: #a75300 !important;
  color: #a75300 !important;
}

.parchment-bulk-delete-dialog__delete-btn--kenya {
  background-color: #a75300 !important;
}
</style>
